import React from 'react'
import { useNavigate } from 'react-router-dom'

const Home = () => {
  const navigate = useNavigate()

  const handleClick = () => {
    const audio = new Audio('/audio2.wav')
    audio.play()
    setTimeout(() => {
      navigate('/home')
    }, 1000)
  }

  return (
    <div className='flex flex-col gap-3 bg-[#000] h-screen justify-center items-center'>
      <h1 className='text-shadow mb-4 text-2xl text-[#715097] lg:text-5xl text-shadow'>Nana Hana</h1>
      <div className='mt-5'>
        <button onClick={handleClick} className="neon-button rounded-lg">
          <span></span><span></span><span></span><span></span>Press to Enter
        </button>
      </div>
    </div>
  )
}

export default Home
